import MembershipModel from "src/models/MembershipModel";
import UserModel from "src/models/UserModel";
import {
  CustomerRequestStatus,
  CustomerRequestType,
} from "types/code-generator";
import ClassModel from "./ClassModel";
import GroupRegistrationModel from "./GroupRegistrationModel";

export const isCustomerRequest = (
  customerRequest
): customerRequest is CustomerRequestModel => {
  return (
    customerRequest?.type === CustomerRequestType.Cancel ||
    customerRequest?.type === CustomerRequestType.Move
  );
};

export default class CustomerRequestModel {
  accountOwner: UserModel;
  cancelling: boolean = false;
  createdAt: Date = new Date();
  declined: boolean = false;
  description: string = "";
  finalDate: Date = new Date();
  groupRegistration: GroupRegistrationModel;
  id: string;
  membership: MembershipModel;
  status: CustomerRequestStatus;
  student: UserModel;
  toClass: ClassModel;
  type: CustomerRequestType;

  constructor(data: CustomerRequestModel | any) {
    Object.assign(this, data);

    if (data?.groupRegistration) {
      this.groupRegistration = new GroupRegistrationModel(
        data.groupRegistration
      );
    }

    if (data?.toClass) {
      this.toClass = new ClassModel(data.toClass);
    }
  }
}
